<template>
    <div id="jlr-booking-widget" :class="{'land-rover-style': this.$store.state.brandId == 2, 'jaguar-style': this.$store.state.brandId == 1}">
        <router-view/>
    </div>
</template>

<script>
    import { cookieHelper } from './cookieHelper'

    export default {
        name: 'app',

        methods: {
            setWidgetParams() {
                this.$store.state.brandId = JLR_BOOKING_WIDGET.brandId;
                this.$store.state.dealerId = JLR_BOOKING_WIDGET.dealerId;
                this.$store.state.locale = JLR_BOOKING_WIDGET.locale || 'ru';
                this.$i18n.locale = this.$store.state.locale;
                this.$store.state.clientVIN = JLR_BOOKING_WIDGET.clientVIN || '';
                this.$store.state.ClientMileage = JLR_BOOKING_WIDGET.ClientMileage || '';



                this.$store.state.ClientLastName = JLR_BOOKING_WIDGET.ClientLastName || '';
                this.$store.state.ClientFirstName = JLR_BOOKING_WIDGET.ClientFirstName || '';
                this.$store.state.ClientPhone = JLR_BOOKING_WIDGET.ClientPhone || '';
                this.$store.state.ClientEmail = JLR_BOOKING_WIDGET.ClientEmail || '';
                this.$store.state.maintenanceSelected.clientInfo = {
                    firstName: this.$store.state.ClientFirstName,
                    middleName: '',
                    lastName: this.$store.state.ClientLastName,
                    phone: this.$store.state.ClientPhone,
                    email: this.$store.state.ClientEmail,
                    terms: false
                };


            },

            makeVisitorId() {
                let visitorId = '';
                const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';

                for (let i = 0; i < 8; i++) {
                    visitorId += possible.charAt(Math.floor(Math.random() * possible.length));
                }

                visitorId += '_' + Date.now();
                return visitorId;
            },

            getVisitorId() {
                return cookieHelper.get('JLR_WIDGET_VISITOR_ID');
            },

            setVisitorId(visitorId) {
                cookieHelper.set('JLR_WIDGET_VISITOR_ID', visitorId);
            }
        },


        created() {
            this.setWidgetParams();

            if(!this.getVisitorId()) {
                const visitorId = this.makeVisitorId();
                this.setVisitorId(visitorId);
            }
        }
    }
</script>

<style lang="less">

    @import (less) './styles/_media.less';
    @import (less) './styles/colors.less';
    @import (less) './styles/paddings.less';
    @import (less) './styles/reset_styles.less';
    @import (less) './styles/steps_styles.less';
    @import url('https://fonts.googleapis.com/css?family=Roboto');

    @font-face {
        font-family: 'Proxima Nova - Semibold';
        src: url('./fonts/ProximaNova-Semibold.eot') format('eot');
        src: url('./fonts/ProximaNova-Semibold.eot?#iefix') format('eot'),
        url('./fonts/ProximaNova-Semibold.woff') format('woff'),
        url('./fonts/ProximaNova-Semibold.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
    }

    #jlr-booking-widget {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        position: relative;
        box-sizing: border-box;
        max-width: 100vw;

        &.land-rover-style {
            font-family: Arial, sans-serif;
            color: @landRoverBlack;
        }

        &.jaguar-style {
            font-family: 'Proxima Nova - Semibold', Helvetica, Arial, sans-serif;
            color: @jaguarBlack;
        }

        .connection-error {
            background: white;
            color: @errorColor;
            font-size: 16px;
            padding: 20px;
            text-align: left;
            .paddings;
        }


        .validation-error {
            text-align: left;
            color: @errorColor;
            font-size: 12px;
            position: relative;
            margin-left: 20px;

            &:before {
                content: '';
                display: block;
                position: absolute;
                left: -20px;
                top: -1px;
                background: url(./icons/error_icon.png);
                background-size: cover;
                height: 15px;
                width: 15px;
            }

        }
        .validation-error-enter-active {
            transform: translateY(0);
            max-height: 100px;
            transition: max-height .5s ease-in, opacity .2s .1s ease-in, transform .3s .2s ease-out;
        }
        .validation-error-leave-active {
            transform: translateY(0);
            max-height: 100px;
            transition: opacity .5s ease-in, max-height .2s .4s ease-in, transform .3s .2s ease-out;
        }
        .validation-error-enter, .validation-error-leave-to {
            max-height: 0 !important;
            transform: translateY(10px);
            opacity: 0;
        }
	
		@media (max-width: 1275px) {
			.v-select .dropdown-menu {
			 transform: translateX(0%);
			 right: 0;
			 bottom: auto;
			}
		}

        .v-select.jlr-select {
            font-size: 10px;
            letter-spacing: 2px;
            position: relative;
            padding-right: 0;

            &.disabled {
                .form-control {
                    background-color: white;
                }
            }

            .no-items {
                padding: 5px;
                color: @errorColor;
                font-size: 9px;
                font-weight: bold;
                display: block;
            }

            .dropdown-toggle {
                border: none !important;
                border-radius: 0;
                text-transform: uppercase;
                height: 100%;
                overflow: hidden;
                position: relative;

                input {
                    border: none;
                    padding: 0;
                    height: inherit;
                }
            }

            .form-control {
                padding: 0;
                text-transform: uppercase;
                height: inherit;
                width: 100% !important;
                position: absolute;
                left: 0;

                .jaguar-style & {
                    font-family: 'Proxima Nova - Semibold', Helvetica, Arial, sans-serif;
                }

                .land-rover-style & {
                    font-family: Arial, sans-serif;
                }
            }

            .selected-tag {
                padding: 0;
                margin: 0;
                white-space: nowrap;

                .jaguar-style & {
                    font-family: 'Proxima Nova - Semibold', Helvetica, Arial, sans-serif;
                }

                .land-rover-style & {
                    font-family: Arial, sans-serif;
                }
            }

            .open-indicator {
                right: -25px;


                &::after {
                    content: '';
                    display: block;
                    width: 40px;
                    height: 30px;
                    background: url('./icons/select_icon.svg') no-repeat 65%,
                                linear-gradient(to left, white 50%, @transparent);
                    position: absolute;
                    top: -8px;
                    left: -55px;
                    cursor: pointer;
                }
            }

            .clear {
                display: none;
            }

            &.open {
                .open-indicator {
                    bottom: 6px;
                }
            }

            .dropdown-menu {
                border: none ;
                border-radius: 0;
                min-width: 153px;
                overflow: auto;
                padding: 0 !important;

                li {
                    text-transform: uppercase;
                    border-top: 1px solid lightgrey;

                    &.highlight {
                        a {
                            .land-rover-style& {
                                background: @landRoverBright;
                            }

                            .jaguar-style& {
                                background: @jaguarBright;
                            }
                        }
                    }

                    a {
                        overflow: hidden;
                        white-space: normal;
                        font-size: 10px;

                        .jaguar-style & {
                            font-family: 'Proxima Nova - Semibold', Helvetica, Arial, sans-serif;
                        }

                        .land-rover-style & {
                            font-family: Arial, sans-serif;
                        }
                    }
                }
            }
        }


        .fade-enter-active {
            max-height: 500px;
            transition: max-height .5s ease-out, opacity .3s .3s ease-in;
        }
        .fade-leave-active {
            max-height: 500px;
            transition: max-height .2s .2s ease-out, opacity .3s ease-in;
        }
        .fade-enter, .fade-leave-to {
            max-height: 0;
        }		
    }
</style>



// WEBPACK FOOTER //
// src/App.vue